import { render, staticRenderFns } from "./JobFormComponent.vue?vue&type=template&id=24e4b79e&scoped=true&"
import script from "./JobFormComponent.vue?vue&type=script&lang=js&"
export * from "./JobFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./JobFormComponent.vue?vue&type=style&index=0&id=24e4b79e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e4b79e",
  null
  
)

export default component.exports